import cx from 'clsx';
import * as React from 'react';

import { MEDIUM_BREAKPOINT } from '@/components/modular-grid/constants';
import GhostTile from '@/components/modular-grid/GhostTile/GhostTile';
import { useWindowSize } from '@/hooks/useWindowSize';

import styles from './GameDual.module.scss';

const GameDualGhost: React.FC = () => {
  const windowWidth = useWindowSize().width;
  const createSlot = (key: number) => (
    <div className={cx(styles.slot, styles.ghost, styles.slotSmall)} key={key}>
      <GhostTile />
    </div>
  );

  const createRow = (array: number[], isMedium: boolean) => (
    <div className={cx(styles.row, isMedium && styles.rowMedium)}>
      {array.map(i => createSlot(i))}
    </div>
  );
  return (
    <div
      className={cx(styles.container, styles.insideHeader)}
      data-testid="game-dual-ghost-grid"
    >
      {windowWidth < MEDIUM_BREAKPOINT.min ? (
        createRow(Array.from(Array(5).keys()), false)
      ) : (
        <div className={styles.rowWrapper}>
          {createRow([0], true)}
          {createRow([1, 2], true)}
          {createRow([3], true)}
          {createRow([4, 5], true)}
        </div>
      )}
    </div>
  );
};
export default GameDualGhost;
